import { useEffect } from "react";

interface JsonLdProps {
  data: Record<string, unknown>;
}

export const JsonLd = ({ data }: JsonLdProps) => {
  useEffect(() => {
    const script = document.createElement("script");
    script.type = "application/ld+json";
    script.textContent = JSON.stringify(data);
    script.setAttribute("data-jsonld", "true");
    document.head.appendChild(script);

    return () => {
      script.remove();
    };
  }, [data]);

  return null;
};

// Prebuilt schema objects
export const organizationSchema = {
  "@context": "https://schema.org",
  "@type": "Organization",
  name: "Tourbi",
  url: "https://tourbi.tech",
  logo: "https://tourbi.tech/og-image.png",
  description:
    "Tourbi empowers tour operators, travel agencies, and DMCs to digitize and scale their operations with comprehensive travel technology solutions.",
  address: {
    "@type": "PostalAddress",
    streetAddress: "KG 171",
    addressLocality: "Kigali",
    addressCountry: "RW",
  },
  contactPoint: {
    "@type": "ContactPoint",
    email: "hello@tourbi.tech",
    contactType: "sales",
  },
  sameAs: [
    "https://www.linkedin.com/company/tourbi",
    "https://www.youtube.com/@tourbi",
  ],
};

export const websiteSchema = {
  "@context": "https://schema.org",
  "@type": "WebSite",
  name: "Tourbi",
  url: "https://tourbi.tech",
  potentialAction: {
    "@type": "SearchAction",
    target: "https://tourbi.tech/?q={search_term_string}",
    "query-input": "required name=search_term_string",
  },
};

export const softwareSchema = {
  "@context": "https://schema.org",
  "@type": "SoftwareApplication",
  name: "Tourbi Travel CRM",
  applicationCategory: "BusinessApplication",
  operatingSystem: "Web",
  url: "https://tourbi.tech",
  description:
    "All-in-one travel technology platform for tour operators, travel agencies, and DMCs.",
  offers: {
    "@type": "AggregateOffer",
    lowPrice: "7",
    highPrice: "25",
    priceCurrency: "USD",
    offerCount: "3",
  },
};

export const faqSchema = (
  faqs: { question: string; answer: string }[]
) => ({
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: faqs.map((faq) => ({
    "@type": "Question",
    name: faq.question,
    acceptedAnswer: {
      "@type": "Answer",
      text: faq.answer,
    },
  })),
});

export const breadcrumbSchema = (
  items: { name: string; url: string }[]
) => ({
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  itemListElement: items.map((item, i) => ({
    "@type": "ListItem",
    position: i + 1,
    name: item.name,
    item: item.url,
  })),
});
